import { render, staticRenderFns } from "./MusicFloatingPlayer.vue?vue&type=template&id=6bd2a66c&scoped=true"
import script from "./MusicFloatingPlayer.vue?vue&type=script&lang=js"
export * from "./MusicFloatingPlayer.vue?vue&type=script&lang=js"
import style0 from "./MusicFloatingPlayer.vue?vue&type=style&index=0&id=6bd2a66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2a66c",
  null
  
)

export default component.exports